import React, { useState } from 'react';

/**
 * Reusable podcast card.
 */
const PodcastCard = ({ series, title, meta, coverStyle, image }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="card podcast-card">
      <div className="podcast-card__cover" style={image ? { backgroundImage: `url(${image})`, backgroundSize: 'cover' } : coverStyle}></div>
      <div className="podcast-card__info">
        <div className="podcast-card__series">{series}</div>
        <div className="podcast-card__title">{title}</div>
        <div className="podcast-card__meta">{meta}</div>
      </div>
      <button
        className={`podcast-card__play${isPlaying ? ' is-playing' : ''}`}
        aria-label="Riproduci"
        onClick={() => setIsPlaying(!isPlaying)}
      >
        <span>{isPlaying ? '⏸' : '▶'}</span>
      </button>
    </div>
  );
};

export default PodcastCard;
